import React from "react";
import Bulb from "react-icons/lib/fa/lightbulb-o";
import Block from "./Block";

const Theory = ({ children }) => (
    <Block tint={120} icon={Bulb} header="Tip">
        {children}
    </Block>
);

export default Theory;



// WEBPACK FOOTER //
// ./src/components/Tip.js